import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'

import { SalesChannelOverlay } from '#app/routes/mocra+/_form+/components/sales-channels/overlay.tsx'
import {
	createSalesChannelDraft,
	type SalesChannelDraft,
} from '#app/routes/mocra+/_form+/components/sales-channels/types.ts'

type Props = {
	readonly onSubmit: (draft: SalesChannelDraft) => void
	readonly defaultValue?: SalesChannelDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function SalesChannelAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: SalesChannelDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add channel'}
			</AddButton>
			<SalesChannelOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createSalesChannelDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
